import React from 'react';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

function Seguimiento() {
    return (
      <div className='seguimiento'>
      <h1>Seguimiento</h1>

      </div>
    )
}

export default Seguimiento
